import './styles.scss';
import { useState } from 'react';
import redIdentity from '../../assets/red-identity.png';

function Questions() {
    const [question, setQuestion] = useState(0);
    const [showQuestion, setShowQuestion] = useState(false);

    const handleQuestions = (id) => {
        if(question === id) {
            setShowQuestion(!showQuestion);
        } else {
            setQuestion(id);
            setShowQuestion(true);
        }
    };

    return (
        <div className='container-questions'>
            <h1>Dúvidas Frequentes</h1>
            <img className="questions-identity" src={redIdentity} alt="DLM" />

            <ul>
                <li>
                    <h2 onClick={() => handleQuestions(1)}><i className={`fas ${showQuestion && question === 1 ? "fa-minus-circle" : "fa-plus-circle"} ml-2 float-right text-custom-2`}></i>O que são varizes?</h2>
                    {question === 1 && showQuestion &&
                        <p>São veias que perderam sua função adequada de conduzir o sangue de volta ao coração. Por isso, acabam se tornando dilatadas, tortuosas e mais visíveis. Em muitos casos, além da mudança estética, vêm acompanhadas de sintomas como peso, dor ou inchaço nas pernas.</p>}
                </li>
                <li>
                    <h2 onClick={() => handleQuestions(2)}><i className={`fas ${showQuestion && question === 2 ? "fa-minus-circle" : "fa-plus-circle"} ml-2 float-right text-custom-2`}></i>Por que é importante tratar?</h2>
                    {question === 2 && showQuestion &&
                        <p>Porque as varizes não são apenas um detalhe visual. Elas revelam uma dificuldade na circulação venosa que, com o tempo, pode causar desconfortos mais intensos ou complicações. Cuidar é um passo para mais saúde, bem-estar e leveza no dia a dia.</p>}
                </li>
                <li>
                    <h2 onClick={() => handleQuestions(3)}><i className={`fas ${showQuestion && question === 3 ? "fa-minus-circle" : "fa-plus-circle"} ml-2 float-right text-custom-2`}></i>Os vasinhos podem virar varizes maiores?</h2>
                    {question === 3 && showQuestion &&
                        <p>Vasinhos e varizes são diferentes entre si. O que pode acontecer é os dois coexistirem, especialmente quando há tendência hereditária ou fatores como sedentarismo e alterações hormonais. Por isso, mesmo que pequenos, é bom avaliar.</p>}
                </li>
                <li>
                    <h2 onClick={() => handleQuestions(4)}><i className={`fas ${showQuestion && question === 4 ? "fa-minus-circle" : "fa-plus-circle"} ml-2 float-right text-custom-2`}></i>Existe idade certa para começar o tratamento de varizes?</h2>
                    {question === 4 && showQuestion &&
                        <p>Não existe uma regra. O mais indicado é procurar orientação quando você perceber algo fora do comum, seja um vasinho novo, uma veia que surgiu, ou uma sensação diferente nas pernas. O cuidado começa na escuta do próprio corpo.</p>}
                </li>
                <li>
                    <h2 onClick={() => handleQuestions(5)}><i className={`fas ${showQuestion && question === 5 ? "fa-minus-circle" : "fa-plus-circle"} ml-2 float-right text-custom-2`}></i>Existe um tratamento ideal para varizes?</h2>
                    {question === 5 && showQuestion &&
                        <p>Não. E esse é justamente o cuidado: entender o que funciona melhor para o seu caso. Alguns pacientes se beneficiam com sessões, outros com procedimentos únicos. Tudo é feito com base em uma avaliação personalizada.</p>}
                </li>
                <li>
                    <h2 onClick={() => handleQuestions(6)}><i className={`fas ${showQuestion && question === 6 ? "fa-minus-circle" : "fa-plus-circle"} ml-2 float-right text-custom-2`}></i>O tratamento é feito de uma vez só ou precisa de várias sessões?</h2>
                    {question === 6 && showQuestion &&
                        <p>Nem sempre. Quando falamos em vasinhos, por exemplo, as sessões costumam ser necessárias. Já para varizes mais calibrosas, existem abordagens em que resolvemos tudo de uma vez, de forma prática e segura.</p>}
                </li>
                <li>
                    <h2 onClick={() => handleQuestions(7)}><i className={`fas ${showQuestion && question === 7 ? "fa-minus-circle" : "fa-plus-circle"} ml-2 float-right text-custom-2`}></i>O procedimento dói?</h2>
                    {question === 7 && showQuestion &&
                        <p>Todo procedimento pode gerar algum desconforto, mas hoje as técnicas estão cada vez mais suaves e cuidadosas. A ideia não é causar dor, e sim trazer alívio — e isso vale desde o primeiro atendimento.</p>}
                </li>
                <li>
                    <h2 onClick={() => handleQuestions(8)}><i className={`fas ${showQuestion && question === 8 ? "fa-minus-circle" : "fa-plus-circle"} ml-2 float-right text-custom-2`}></i>E se eu tiver receio de cirurgia?</h2>
                    {question === 8 && showQuestion &&
                        <p>Esse medo é compreensível e deve ser respeitado. Nem todo caso exige cirurgia, e mesmo quando ela é necessária, o que oferecemos são abordagens menos invasivas, com recuperação mais rápida e foco total na segurança.</p>}
                </li>
                <li>
                    <h2 onClick={() => handleQuestions(9)}><i className={`fas ${showQuestion && question === 9 ? "fa-minus-circle" : "fa-plus-circle"} ml-2 float-right text-custom-2`}></i>É necessário repouso após o tratamento de varizes?</h2>
                    {question === 9 && showQuestion &&
                        <p>A maioria das pacientes consegue seguir a rotina normalmente, com apenas alguns cuidados nos primeiros dias. Sempre conversamos sobre isso na consulta para ajustar às suas necessidades.</p>}
                </li>
                <li>
                    <h2 onClick={() => handleQuestions(10)}><i className={`fas ${showQuestion && question === 10 ? "fa-minus-circle" : "fa-plus-circle"} ml-2 float-right text-custom-2`}></i>As varizes podem voltar depois do tratamento?</h2>
                    {question === 10 && showQuestion &&
                        <p>De modo geral, o que tratamos não volta. Mas, como o nosso corpo está sempre mudando, novas veias podem surgir com o tempo. Por isso o acompanhamento é tão importante — ele mantém os resultados e previne novos incômodos.</p>}
                </li>


            </ul>

        </div>
    );
}

export default Questions;
